import { gql } from "@apollo/client";
import DataTableLabel from "controls/DataTableLabel";
import useData from "hooks/useData";
import React from "react";

import ReadminLabelDetails, { ReadminLabelDetailsFragement } from "./ReadminLabelDetails";

export const ReadminObjectLabelsFragment = gql`
  fragment ReadminObjectLabelsFragment on ReadminObject {
    readminLabels {
      content
      detail
      type
      ...ReadminLabelDetailsFragement
    }
  }
  ${ReadminLabelDetailsFragement}
`;

export default function ReadminObjectLabels({ id, typename, readminObject }) {
  const [data] = useData(
    gql`
      query ReadminObjectLabels($typename: String, $id: ID) {
        readminObject(typename: $typename, id: $id) {
          id
          ...ReadminObjectLabelsFragment
        }
      }
      ${ReadminObjectLabelsFragment}
    `,
    {
      typename,
      id,
    },
  );

  readminObject ||= data?.readminObject;

  return (
    <>
      {readminObject?.readminLabels?.map((label, labelIndex) => (
        <DataTableLabel
          key={labelIndex}
          label={[label.content, label.detail].filter(Boolean).join(": ")}
          description={label.description}
          detailedDescription={<ReadminLabelDetails label={label} />}
          type={label.type}
        />
      ))}
    </>
  );
}
